export const ATT_DASH_PRE_FILTERS_NECESSARY_FILTERS = ["startDate", "endDate"];
//# sourceMappingURL=index.js.map